import React from 'react';
import { SvgIconProps } from '@mui/material';

const ThumbsUpDownIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='Thumbs Up Default'>
        <circle
          id='Background'
          cx='16'
          cy='16'
          r='15.5'
          fill={props?.fill ?? '#F3FBFF'}
          transform={props?.rotate ? 'rotate(-180 16 16)' : ''}
          stroke={props?.stroke ?? '#008369'}
        />
        <g id='Thumbs Up' transform={props?.rotate ? 'rotate(-180 16 16)' : ''}>
          <path
            id='Vector'
            d='M17.7548 9.10532V12.3569H22.3558C22.5915 12.3542 22.8249 12.4028 23.0399 12.4994C23.2549 12.5959 23.4464 12.7379 23.601 12.9158C23.7557 13.0936 23.8698 13.303 23.9355 13.5293C24.0012 13.7557 24.017 13.9936 23.9816 14.2266L22.8598 21.5427C22.801 21.9303 22.6041 22.2837 22.3053 22.5377C22.0066 22.7916 21.6261 22.929 21.234 22.9246H12.0645H9.6258C9.19461 22.9246 8.78108 22.7533 8.47619 22.4484C8.17129 22.1435 8 21.73 8 21.2988V15.6085C8 15.1773 8.17129 14.7638 8.47619 14.4589C8.78108 14.154 9.19461 13.9827 9.6258 13.9827H12.0645L15.3161 6.66663C15.9629 6.66663 16.5832 6.92356 17.0405 7.3809C17.4979 7.83825 17.7548 8.45854 17.7548 9.10532Z'
            fill='white'
            stroke={props?.stroke ?? '#008369'}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Line'
            d='M12 14.0952V22.6666'
            stroke={props?.stroke ?? '#008369'}
          />
        </g>
      </g>
    </svg>
  );
};

export default ThumbsUpDownIcon;
